<template>
  <div class="row">
    <div class="col-md-6">
      <div class="btn-group">
        <button type="button" class="btn btn-default dropdown-toggle button-filter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{ search.profession || $t("profession") }}<span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li @click="professionSearch({ id: null, name: null })">
            <a>{{ $t("profession") }}</a>
          </li>
          <li @click="professionSearch(profession)" v-for="profession in professions">
            <a>{{ profession.name }}</a>
          </li>
        </ul>
      </div><!-- .btn-group -->
    </div><!-- .col-md-6 -->
    <div class="col-md-6">
      <div class="btn-group" :class="location_dropdown">
        <button type="button" class="btn btn-default dropdown-toggle button-filter" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
          {{ $t("location") }}<span class="caret"></span>
        </button>
        <div class="dropdown-menu location">
          <div class="form-group mt-20">
            <input v-model="search.city" class="form-control" :placeholder="$t('city')">
          </div>
          <div class="form-group mt-20">
            <select v-if="countries.length" v-model="search.country_id" class="form-control" @change="show_location_dropdown()">
              <option disabled value="">{{ $t("country") }}</option>
              <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
            </select>
          </div>
          <button @click="setSearch()" class="btn btn-default btn-lg button-wide">{{ $t("find") }}</button>
        </div>
      </div><!-- .btn-group -->
    </div><!-- .col-md-6 -->
  </div>
</template>

<script>
import dictionariesApi from '@/api/v1/shared/dictionaries';
import usersApi from '@/api/v1/user';

export default {
  props: ['categories', 'type'],
  data() {
    return {
      countries: [],
      professions: [],
      location_dropdown: null,
    };
  },
  computed: {
    search() {
      return {
        country_id: this.$route.query.country_id,
        city: this.$route.query.city,
        profession_id: this.$route.query.profession_id,
        profession: this.$route.query.profession,
      };
    },
  },
  methods: {
    setSearch() {
      this.refineSearchParams();
      this.$router.push({ name: 'profiles', query: this.search });
    },
    professionSearch(profession) {
      this.search.profession_id = profession.id;
      this.search.profession = profession.name;
      this.refineSearchParams();
      this.$router.push({ name: 'profiles', query: this.search });
    },
    // Remove empty params from search query
    refineSearchParams() {
      const vm = this;
      Object.keys(this.search).forEach((key) => {
        if (!vm.search[key]) delete vm.search[key];
      });
    },
    show_location_dropdown() {
      this.location_dropdown = 'open';
    },
    hide_location_dropdown(e) {
      if (e.target.className === 'form-control') {
        e.stopPropagation();
      } else if (this.location_dropdown === 'open') {
        this.location_dropdown = null;
      }
    },
  },
  created() {
    dictionariesApi.getCountries((countries) => {
      this.countries = countries;
      this.countries.unshift({ name: 'None', id: null });
    });
    usersApi.getProfessions((professions) => { this.professions = professions; });
  },
  mounted() {
    document.body.addEventListener('click', (e) => { this.hide_location_dropdown(e); });
  },
};
</script>



// WEBPACK FOOTER //
// Search.vue?935213f6